import service from '@/store/services/cash-registers-service';

const state = {
    list: {},
    cashRegister: {},
    meta: {},
    lastAddedCashRegister: {
        uniqueNumber: null,
        serialNumber: null,
    },
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, cashRegister) => {
        state.cashRegister = cashRegister;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    },
    SET_LAST_ADDED_CASH_REGISTER: (state, lastAddedCashRegister) => (state.lastAddedCashRegister = lastAddedCashRegister),
};

const actions = {
    list({ commit, dispatch }, params) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get({ commit, dispatch }, params) {
        return service.get(params)
            .then((role) => { commit('SET_RESOURCE', role); });
    },

    add({ commit, dispatch }, params) {
        return service.add(params)
            .then((cashRegister) => { commit('SET_RESOURCE', cashRegister); });
    },

    generateToken({ commit, dispatch }, params) {
        return service.generateToken(params)
            .then((cashRegister) => { commit('SET_RESOURCE', cashRegister); });
    },

    getToken({ commit, dispatch }, params) {
        return service.getToken(params)
            .then((cashRegister) => { commit('SET_RESOURCE', cashRegister); });
    },

    update({ commit, dispatch }, params) {
        return service.update(params)
            .then((cashRegister) => { commit('SET_RESOURCE', cashRegister); });
    },

    updateLocation({ commit, dispatch }, params) {
        return service.updateLocation(params)
            .then((cashRegister) => { commit('SET_RESOURCE', cashRegister); });
    },

    destroy({ commit, dispatch }, params) {
        return service.destroy(params);
    },

    setLastAddedCashRegister({ commit, dispatch }, lastAddedCashRegister) {
        setTimeout(()=>{
            lastAddedCashRegister.uniqueNumber = '';
            lastAddedCashRegister.serialNumber = '';
        }, 8000)
        commit('SET_LAST_ADDED_CASH_REGISTER', lastAddedCashRegister);
    },

    listFromLocation({ commit, dispatch }, params) {
        return service.listFromLocation(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    cashRegister: state => state.cashRegister,
    url: state => state.url,
    lastAddedCashRegister: state => state.lastAddedCashRegister,
};

const cashRegisters = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default cashRegisters;